<div class="row">
  <div class="col-lg-7 col-sm-12 col-xs-12">
    <p class="h5 text-left py-2 text-muted"><strong>Pay By Gift Card</strong></p>
  </div>
</div>
<a (click)="add($event)" *ngIf="!isAddingGiftCard" class="h6 text-left py-2 text-muted" data-testid="add-gift-card-button"
  ><strong><i class="fas fa-plus-circle text-success"></i> ADD A VISTEK GIFT CARD</strong></a
>
<div class="row align-items-center" *ngIf="card">
  <div class="col col-auto">{{ card.Card}}</div>
  <div class="col col-auto">
    <button mdbRipple type="button" class="btn btn-primary mr-1" (click)="remove()" data-testid="remove-gift-card-button">
      <i class="fa fa-trash-alt"></i>
    </button>
  </div>
</div>
<form *ngIf="isAddingGiftCard" [formGroup]="giftCardForm" (ngSubmit)="onSubmit()">
  <div class="row">
    <!--Grid column-->
    <div class="col">
      <!--firstName-->
      <div class="md-form">
        <input
          type="text"
          id="card"
          class="form-control"
          formControlName="Card"
          mdbInput
          mdbValidate 
          #cardInput
          data-testid="gift-card-number-input"
        />
        <mdb-error *ngIf="hasError('Card', 'required')">Gift Card Number is required</mdb-error>
        <mdb-error *ngIf="hasError('Card', 'unique')">Gift Card Number is already used</mdb-error>
        <mdb-error *ngIf="hasError('Card', 'server')">{{giftCardForm.get('Card').errors['server'][0]}}</mdb-error>
        <label for="card" class="">Gift Card Number</label>
      </div>
    </div>
    <!--Grid column-->
    <div class="col col-md-2">
      <!--firstName-->
      <div class="md-form">
        <input
          type="text"
          id="pin"
          class="form-control"
          formControlName="Pin"
          mdbInput
          mdbValidate
          data-testid="gift-card-pin-input"
        />
        <mdb-error *ngIf="hasError('Pin', 'required')">Pin is required</mdb-error>
        <mdb-error *ngIf="hasError('Pin', 'server')">{{giftCardForm.get('Pin').errors['server'][0]}}</mdb-error>
        <label for="pin" class="">Pin</label>
      </div>
    </div>
    <div class="col col-auto align-self-center">
        <button mdbRipple type="submit" class="btn btn-primary mr-1" data-testid="add-gift-card-submit-button">Add</button>
        <button mdbRipple type="button" class="btn btn-primary" (click)="cancel()" data-testid="add-gift-card-cancel-button">Cancel</button>
    </div>
  </div>
</form>
